'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _CompanyIsFff = require('./CompanyIsFff.css');

var _CompanyIsFff2 = _interopRequireDefault(_CompanyIsFff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyIsFff = (_dec = (0, _reactCssModules2.default)(_CompanyIsFff2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyIsFff, _Component);

  function CompanyIsFff(props) {
    (0, _classCallCheck3.default)(this, CompanyIsFff);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyIsFff.__proto__ || (0, _getPrototypeOf2.default)(CompanyIsFff)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(CompanyIsFff, [{
    key: 'render',
    value: function render() {
      var iconFfb = require('../../../static/images/icn-ffb.svg');
      var iconFfi = require('../../../static/images/icn-ffi.svg');
      var iconC2 = require('../../../static/images/icn-c2.svg');
      var iconCo = require('../../../static/images/icn-co.svg');
      var iconOg = require('../../../static/images/icn-og.svg');
      var iconF5 = require('../../../static/images/icn-f5.svg');
      var iconUt = require('../../../static/images/icn-ut.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'family-modal' },
        _react2.default.createElement(
          'div',
          { styleName: 'icon-row' },
          this.props.company.is_c2 ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconC2, title: 'Top 200 carbon reserve owner', color: 'red' }) : null,
          this.props.company.is_f15 ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconC2, title: 'Top 50 Coal-fired utilities', color: 'red' }) : null,
          this.props.company.is_co ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconCo, title: 'Coal industry' }) : null,
          this.props.company.is_og ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconOg, title: 'Oil/gas industry' }) : null,
          this.props.company.is_ut ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconUt, title: 'Fossil-fired utilities' }) : null,
          this.props.company.is_fossil_bank ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconFfb, title: 'Fossil fuel finance' }) : null,
          this.props.company.is_fossil_insure ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconFfi, title: 'Fossil fuel insurance' }) : null
        )
      );
    }
  }]);
  return CompanyIsFff;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = CompanyIsFff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsFff.js
// module id = 1379
// module chunks = 0